<template>
  <NuxtTime
    v-if="date"
    :datetime="date"
    :hour="time ? 'numeric' : undefined"
    :minute="time ? 'numeric' : undefined"
    :month="month"
    day="numeric"
    :year="year"
  />
</template>

<script lang="ts" setup>
withDefaults(defineProps<{
  date: string | Date | null
  time?: boolean
  month?: 'short' | 'long'
  year?: 'numeric' | '2-digit'
}>(), {
  time: true,
  month: 'long',
  year: 'numeric',
})
</script>
